import React, { useReducer, useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import moduleConfig from "./moduleConfig"
import { detailsInitialState, detailsReducer } from "../../../reducers/module/detailsReducer";
import Details from "./partials/details/Details";



import useConfirm from "../../../HOC/custom/useConfirm";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import { Button } from "react-bootstrap";

import PaymentAcceptModal from "./partials/details/PaymentAcceptModal";
import { loadItemGeneral } from "../../../helpers/ModuleHelperFunctions";
let breadcrumbs = {
    listing: {
        label: moduleConfig.title,
        url: `/${moduleConfig.url}`
    },
    details: {
        label: "Details",
    }
};

const PaymentView = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [detailsState, detailsDispatch] = useReducer(detailsReducer,detailsInitialState);
  
  let { id } = useParams();
  
  const loadItem = async () => {
    await loadItemGeneral(id,`${moduleConfig.url}/${id}`,detailsDispatch)
  };
  useEffect(() => {
    loadItem();
    setBreadcrumb([moduleConfig.breadcrumbs.listing, moduleConfig.breadcrumbs.details]);
  }, [id]);

    return (<DashboardLayout >

        {(detailsState.isFetching)
            ? <ContainerLoading />
            : <>
                {(detailsState.hasError)

                    ? <BlockErrorMessage error={detailsState.error} />
                    : <>
                        {
                            (detailsState.data.item) &&
                            <>
                                <ModuleHeader
                                    moduleTitle={`View ${moduleConfig.singleItemTitle}`}
                                    moduleUrl={moduleConfig.url}
                                ></ModuleHeader>

                                <Details
                                    item={detailsState.data.item}
                                    moduleConfig={moduleConfig}
                                />
                            </>
                        }
                    </>
                }
            </>
        }
    </DashboardLayout>);
}

export default PaymentView;


